export const callValidateByDecision = <T>(
  doValidate: boolean,
  validateCallback: (value: T) => Promise<string> | string
) => {
  if (doValidate) {
    return validateCallback
  }

  return undefined
}
